document.addEventListener('click', async function (e) {
    const btn = e.target.closest('#btnModalEditarTipoReferencia');
    if (!btn) return;

    const id          = btn.getAttribute("data-id");
    const formEditar  = document.querySelector("#formEditarTipoReferencia");
    const modalEditar = document.querySelector("#ModalEditarTipoReferencia");

    if (!id || !formEditar || !modalEditar) {
        if (typeof lanzarAlerta === 'function') lanzarAlerta("Faltan parámetros para editar el tipo de referencia.", "alerta-roja");
        return;
    }

    try {
        const response = await fetch(`/api/configuracion/tipo-referencia/infoTipoReferencia?idTipoReferencia=${id}`, {
            method: "GET",
            credentials: "include",
            headers: { "Content-Type": "application/json" }
        });

        if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);

        const result = await response.json();
        const data   = result.result[0];

        if (!data) {
            if (typeof lanzarAlerta === 'function') lanzarAlerta("No se encontró información del tipo de referencia.", "alerta-roja");
            setTimeout(() => { window.location.reload(); }, 1500);
            return;
        }

        modalEditar.classList.add('modal--show');

        const inputId     = formEditar.querySelector('#idTipoReferenciaEditar');
        const inputNombre = formEditar.querySelector('#tipoReferenciaEditarDisplay');
        const divSwitch   = formEditar.querySelector('#divSwitchTipoReferencia');

        if (inputId)     inputId.value     = data.idTipoReferencia    || "";
        if (inputNombre) inputNombre.value = data.tipoReferencia || "";

        const checked     = Number(data.estado) === 1 ? 'checked' : '';
        const textoEstado = Number(data.estado) === 1 ? 'ACTIVO' : 'INACTIVO';

        divSwitch.innerHTML = `
            <span class="labelInfo">Estado:</span>
            <label class="switchEstado">
                <input id="estado" type="checkbox" name="estado" value="${data.estado}" ${checked}>
                <span class="sliderEstado"></span>
                <span class="textoEstado">${textoEstado}</span>
            </label>
        `;

    } catch (error) {
        console.error("Error al obtener información del tipo de referencia:", error);
        if (typeof lanzarAlerta === "function") lanzarAlerta("No se pudo cargar la información del tipo de referencia.", "alerta-roja");
    }
});

document.addEventListener('submit', async (e) => {
    if (e.target.id !== 'formEditarTipoReferencia') return;
    e.preventDefault();

    const formulario = e.target;
    const btnSubmit  = formulario.querySelector('#btnEditarTipoReferencia');
    const spinner    = formulario.querySelector('#spinner');
    const formData   = new FormData(formulario);

    if (!btnSubmit || !spinner) {
        if (typeof lanzarAlerta === 'function') lanzarAlerta("Faltan parámetros para editar el tipo de referencia.", "alerta-roja");
        return;
    }

    btnSubmit.disabled = true;
    spinner.style.display = 'inline-block';

    try {
        const respuesta = await fetch('/api/configuracion/tipo-referencia/editar', { method: 'POST', body: formData });
        const json      = await respuesta.json();
        const status    = respuesta.status;
        const resultado = json.result;

        if (status !== 200) {
            alert("Error crítico al procesar la solicitud.");
            setTimeout(() => { window.location.reload(); }, 1500);
            return;
        }

        if (resultado.hayErrores) {
            resultado.errores.forEach(error => {
                lanzarAlerta(error.mensaje, error.clase);
                const campo = formulario.querySelector(`[name="${error.campo}"]`);
                if (campo) campo.classList.add('inputRojo');
            });
            btnSubmit.disabled = false;
            spinner.style.display = 'none';
        } else {
            lanzarAlerta("Tipo de referencia editado correctamente.", "alerta-verde");
            setTimeout(() => { window.location.reload(); }, 800);
        }

    } catch (error) {
        console.error("Error:", error);
        btnSubmit.disabled = false;
        spinner.style.display = 'none';
    }
});
